import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../core/auth/auth.service';
import { RolesEnum } from '../core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    standalone: false
})
export class HomeComponent implements OnInit {

    currentRole: string;

    constructor(private router: Router, private authService: AuthService) { }

    ngOnInit(): void {
        const roles = this.authService.user?.realm_access?.roles || [];
        const has = (r: RolesEnum) => Array.isArray(roles) && roles.includes(r);

        console.log('Current Roles:', roles);
        
        if (has(RolesEnum.GESTAO_ADMIN)) {
            console.log('Navigating to /dashboard');
            this.router.navigateByUrl('/dashboard', { replaceUrl: true });
        } else if (has(RolesEnum.FUNCIONARIO)) {
            this.router.navigateByUrl('/pendencias/atesto', { replaceUrl: true });
        } else if (has(RolesEnum.FISCAL)) {
            this.router.navigateByUrl('/pendencias/validacao', { replaceUrl: true });
        } else if (has(RolesEnum.AFERIDOR)) {
            this.router.navigateByUrl('/pendencias/afericao', { replaceUrl: true });
        } else if (has(RolesEnum.COORDENADOR)) {
            this.router.navigateByUrl('/pendencias/afericao', { replaceUrl: true });
        } else {
            this.router.navigateByUrl('/dio', { replaceUrl: true });
        }
        
    }
}
